// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
import type {
  IGetProjectsRequest,
  TGetProjectsModel,
  IMappers,
  TGetProjectsResponse,
  TGetProjectsResponse_1,
  TGetProjectsResponseError,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';

export const defaultConfig: TGetProjectsModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'promotions-flow-control',
  pathApi: '/v1/get-projects/',
  interserviceAuthEnabled: true,
} as TGetProjectsModel;

export function createGetProjectsModel(parameters: IGetProjectsRequest): TGetProjectsModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetProjectsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetProjectsRequest;
}

export async function fetchGetProjects<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetProjectsOptions<TResponse200, TResponse400>): Promise<TGetProjectsResponse | TResponse200 | TResponse400> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetProjectsModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TGetProjectsResponse_1);
    }
    if (statusCode === 400) {
      return mappers[400](response as TGetProjectsResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetProjectsResponse;
}
